
import React from 'react';
import ServiceCard from './ServiceCard';
import { Shield, Computer, Wifi, Clock, HardDrive, WrenchIcon } from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: Computer,
      title: 'Computer Repair & Support',
      description: 'Expert diagnosis and repair for desktop and laptop computers, including virus removal, performance optimization, and hardware upgrades.',
      features: [
        'Virus & Malware Removal',
        'PC & Mac Repairs',
        'Hardware Upgrades',
        'Data Recovery'
      ]
    },
    {
      icon: Wifi,
      title: 'Home Network Solutions',
      description: 'Professional setup and optimization of your home network for reliable, secure connectivity throughout your entire home.',
      features: [
        'Wi-Fi Installation & Optimization',
        'Mesh Network Setup',
        'Network Security',
        'Printer & Device Connection'
      ]
    },
    {
      icon: Shield,
      title: 'Home Security Solutions',
      description: 'Protect your digital life with comprehensive security solutions tailored for homeowners and families.',
      features: [
        'Password Management',
        'Antivirus Installation',
        'Data Backup Solutions',
        'Identity Protection'
      ]
    },
    {
      icon: WrenchIcon,
      title: 'Smart Home Integration',
      description: 'Setup and integration of smart home devices to create a connected, efficient home environment.',
      features: [
        'Smart Speaker Setup',
        'Smart Lighting & Thermostat',
        'Home Automation',
        'Video Doorbell & Security Cameras'
      ]
    },
    {
      icon: Clock,
      title: 'Tech Tutoring & Training',
      description: 'Patient, personalized instruction to help you get the most out of your technology.',
      features: [
        'Computer Basics',
        'Software Training',
        'Mobile Device Assistance',
        'Online Safety Education'
      ]
    },
    {
      icon: HardDrive,
      title: 'Data Backup & Recovery',
      description: 'Protect your important files and memories with secure backup solutions and data recovery services.',
      features: [
        'Cloud Backup Setup',
        'External Drive Configuration',
        'Photo & Document Recovery',
        'Automated Backup Solutions'
      ]
    }
  ];

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Our Residential IT Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive technology solutions for homeowners, bringing enterprise-grade 
            expertise to residential settings.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              features={service.features}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
